<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">Manage Corporate Pass</h3>
                </div>
                <div class="col-auto float-right ml-auto">
                    <button class="btn add-btn" @click="add">
                        <i class="fa fa-plus"></i>New Pass
                    </button>
                    <button class="btn remove-btn mr-3" @click="remove" :disabled="isDeleteButtonDisabled">
                        <i class="fa fa-trash mr-1"></i>Delete Selected
                    </button>

                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Filter -->
        <div class="row align-items-center">
            <div class="col-md-1 fit-content">Company</div>
            <div class="col-md-4 pl-md-0 fit-content">
                <select class="custom-select" v-model="company" @change="getCorporatePass">
                    <option v-for="(item, i) in companies" :key="i" :value="item.CompanyName">
                        {{ item.CompanyName }}
                    </option>
                </select>
            </div>
            <div class="col-md-1 fit-content">Type</div>
            <div class="col-md-4 pl-md-0 fit-content">
                <select class="custom-select" v-model="type" @change="getCorporatePass">
                    <option value="">All</option>
                    <option :value="corporatePassType.physicalCard">{{ corporatePassType.physicalCard }}</option>
                    <option :value="corporatePassType.eTicket">{{ corporatePassType.eTicket }}</option>
                </select>
            </div>
            <div class="col-md-1 fit-content">Status</div>
            <div class="col-md-4 pl-md-0 fit-content">
                <select class="custom-select" v-model="status" @change="getCorporatePass">
                    <option value="">All</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                </select>
            </div>
        </div>
        <!-- /Filter -->

        <!-- Table -->
        <div class="row mt-4">
            <div class="col-md-12">
                <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
                    <table class="table table-bordered custom-table mb-0" style="width:100%">
                        <thead class="thead-light">
                            <tr>
                                <th class="text-center" style="width: 1%">
                                    <input type="checkbox" v-model="checkAll" @change="toggleCheckAll($event)" />
                                </th>
                                <th>Code</th>
                                <th>Name</th>
                                <th>Type</th>
                                <th style="width:5%">Total Pass</th>
                                <th style="width:8%">Pass Balance</th>
                                <th style="width:15%">Pass Allowed per Booking</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in records" :key="item.Id">
                                <td class="text-center">
                                    <input type="checkbox" v-model="item.IsSelected" @change="onItemCheckChanged" />
                                </td>
                                <td class="link-underline">
                                    <router-link :to="{ name: 'manageCorporatePassEdit', params: { id: item.Id } }">
                                        {{ item.Code }}
                                    </router-link>
                                </td>
                                <td>{{ item.Name }}</td>
                                <td>{{ item.Type }}</td>
                                <td>{{ item.TotalPass }}</td>
                                <td>{{ item.PassBalance }}</td>
                                <td>{{ item.PassAllowedPerBooking }}</td>
                                <td>{{ item.Status }}</td>
                            </tr>
                            <tr v-if="records && !records.length">
                                <td colspan="7" class="text-center">
                                    {{ this.noRecordText }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- /Table -->

    </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
    data() {
        return {
            records: [],
            companies: [],
            company: config.DEFAULT_COMPANY,
            status: "",
            noRecordText: config.NO_RECORD_TEXT,
            checkAll: false,
            selectedIds: [],
            type: ""
        }
    },

    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
        isDeleteButtonDisabled() {
            for (let item of this.records) {
                if (item.IsSelected) return false;
            }
            return true;
        },
        corporatePassType() {
            let type = {
                physicalCard: config.CORPORATE_PASS_TYPE_PHYSICAL_CARD,
                eTicket: config.CORPORATE_PASS_TYPE_ETICKET
            }
            return type;
        }
    },

    methods: {
        //filter
        getCompanies() {
            let param = {
                Token: this.token,
            };
            this.$store.state.isLoading = true;
            API.getCompanies(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.companies = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        //table
        getCorporatePass() {
            this.checkAll = false;
            let param = {
                Token: this.token,
                Company: this.company,
                Type: this.type,
                Status: this.status
            };
            this.$store.state.isLoading = true;
            API.getCorporatePass(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.records = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        toggleCheckAll($event) {
            let isChecked = $event.target.checked;
            for (let item of this.records) {
                item.IsSelected = isChecked;
            }
        },
        onItemCheckChanged() {
            let allItemChecked = true;
            for (let item of this.records) {
                if (!item.IsSelected) {
                    allItemChecked = false;
                    break;
                }
            }
            this.checkAll = allItemChecked;
        },
        //action
        add() {
            this.$router.push({ name: "manageCorporatePassAdd" });
        },
        remove() {
            let param = {
                Token: this.token,
                Ids: this.records.filter(c => c.IsSelected == true).map(c => c.Id)
            };
            this.$swal({
                title: "Are you sure?",
                text: "Are you sure you want to delete the selected corporate pass?",
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willDelete) => {
                if (willDelete) {
                    this.$store.state.isLoading = true;
                    API.deleteCorporatePass(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, {
                                icon: response.data.success ? "success" : "error",
                            });
                            if (response.data.success) {
                                this.getCorporatePass();
                            }
                        })
                        .catch((error) => {
                            this.$store.state.isLoading = false;
                            this.$swal(error.response.data.Message, { icon: "error" });
                        });
                }
            });
        }
    },

    created() {
        if (this.role != "admin") {
            this.$router.replace({ name: "home" });
        }
        this.getCompanies();
        this.getCorporatePass();
    }

}
</script>

<style scoped>
.remove-btn {
    background-color: #dc3545;
    border: 1px solid #dc3545;
    border-radius: 50px;
    color: #fff;
    float: right;
    font-weight: 500;
    min-width: 140px;
}

.fit-content {
    max-width: fit-content;
}

.link-underline a:hover {
    text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/Corppass/ManageCorporatePass.vue